import sel from '~/selectors'

export default sel as { [key: string]: any }
